import { render, staticRenderFns } from "./DoctorIntroduction.vue?vue&type=template&id=b640f5de&scoped=true&"
import script from "./DoctorIntroduction.vue?vue&type=script&lang=js&"
export * from "./DoctorIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./DoctorIntroduction.vue?vue&type=style&index=0&id=b640f5de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b640f5de",
  null
  
)

export default component.exports